import _ = require("underscore");
import template = require("../templates/toolbar-template");
import Base = require("./base-view");
import deepExtend = require("../utils/deep-extend");

class View extends Base<any> {

    static about = `
View using templates/toolbar-template.

Usage Example:

    <CONTROL id="toolbar" mid="app/controls/view">
    <OPTIONS>
        <Values about="identify a template containing view regions" id="template" value="app/templates/toolbar-template" />
        <Values id="view" value="app/views/ToolbarView" />
    </OPTIONS>
    </CONTROL>

`;


    static options = deepExtend({
        "className": {
            "default": "toolbar",
        },
        "template": {
            "about": "overrides the default template",
        },
    }, Base.options);

    execute(options) {

        return super.execute(_.defaults(options, {
            template: template,
            className: "toolbar"
        }));

    }

}

export = View; 